import { makeAutoObservable } from "mobx";
class Store {
  platform = 1;
  showTab = true;
  activeRoute = "/home";
  authModal = false;
  isDirty = false;
  dirtyVisible = false;
  switchVisible = false;
  nextPath = '';
  constructor() {
    makeAutoObservable(this);
  }
  updatePlatform(tab) {
    this.platform = tab;
  }
  updateShowTab(show) {
    this.showTab = show;
  }
  updateActiveRoute(route) {
    this.activeRoute = route;
  }
  updateAuthModal(modal) {
    this.authModal = modal;
  }
  updateIsDiyty(value) {
    this.isDirty = value
  }
  updateDirtyVisible(value) {
    this.dirtyVisible = value
  }
  updateSwitchVisible(value) {
    this.switchVisible = value
  }
  updateNextPath(value) {
    this.nextPath = value
  }
}
const store = new Store();
export default store;
